import { type FC } from 'react';
import { type SbSharedStorefrontLink_browseContentModule$data } from './__generated__/SbSharedStorefrontLink_browseContentModule.graphql.ts';
import { type SbSharedStorefrontLink_user$data } from './__generated__/SbSharedStorefrontLink_user.graphql.ts';

import { SbSharedStorefrontLinkBase } from './SbSharedStorefrontLinkBase.tsx';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

type Props = {
    browseContentModule: SbSharedStorefrontLink_browseContentModule$data;
    user: SbSharedStorefrontLink_user$data | null | undefined;
};

const SbSharedStorefrontLinkComponent: FC<Props> = ({ browseContentModule, user }) => {
    return <SbSharedStorefrontLinkBase browseContentModule={browseContentModule} user={user} />;
};

export const SbSharedStorefrontLink = createFragmentContainer(SbSharedStorefrontLinkComponent, {
    user: graphql`
        fragment SbSharedStorefrontLink_user on User {
            ...sellerBrandingHelpers_user
        }
    `,
    browseContentModule: graphql`
        fragment SbSharedStorefrontLink_browseContentModule on ContentModuleRegular {
            seller {
                ...sellerBrandingHelpers_seller
                sellerProfile {
                    company
                }
                sellerPreferences {
                    urlLabel
                }
                liveStorefrontProfile {
                    status
                }
            }
        }
    `,
});
